// Guide Block Types:
// - "section": { id: string, title: string, content: []}
// - "subsection": { title: string, content: [] }
// - "subdivision": { title: string, content: [] }
// - "text": { data: string | () => JSX }
// - "image": { data: string (url) }
// - "gallery": { images: [{ src, alt, credit: { name, url } }] }
// - "table": { data: [ { row: {} }]}
// - "list": { data: string (newline separated list) }
// - "component": { data: string (key to componentMap) }
// - "inlineLink": { text: string, onClick: fn }

const MiscellaneousGuides = {
  id: "miscellaneous",
  title: "Miscellaneous Info",
  category: "Guides",
  slug: "misc",
  sections: [
    {
      id: "terravilla",
      title: "Terra Villa",
      type: "section",
      content: [],
    },
    {
      id: "buildings",
      title: "Buildings in TV",
      type: "section",
      content: [],
    },
    {
      id: "npcs",
      title: "NPCs of TV",
      type: "section",
      content: [],
    },
  ],
};

export default MiscellaneousGuides;
